import { usePersonTagQuery } from '@v2/domains/person/api/person.api'
import { selectCurrentOrganization } from '@v2/domains/user/selectors/user.selectors'
import { useAppSelector } from '@v2/store/hooks'

export interface IPersonsTags {
  personTags: string[] | []
}

const usePersonTags = () => {
  const { id: orgId } = useAppSelector(selectCurrentOrganization)

  const { data, isLoading, isSuccess } = usePersonTagQuery(
    { orgId },
    { refetchOnMountOrArgChange: true },
  )

  return {
    personTags: data?.records.map(({ name }) => name) || [],
    tags: data?.records ?? [],
    totalRecords: data?.totalRecords,
    isLoading,
    isSuccess,
  }
}

export default usePersonTags
